import React, { FC } from 'react';
import { Dropdown } from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';
import cls from './RowActionsDropdown.module.scss';

export type RowAction = {
  label: string;
  onSelect: () => void;
  /** Marks a destructive action, e.g. deletion */
  danger?: boolean;
  disabled?: boolean;
};

type RowActionsDropdownProps = {
  /** Part of the toggle id, so every row carries its own */
  id: string;
  actions: RowAction[];
};

const RowActionsDropdown: FC<RowActionsDropdownProps> = ({ id, actions }) => {
  // the row itself navigates, so a click inside the menu must not reach it
  const clickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };
  return (
    <Dropdown onClick={clickHandler} align="end">
      <Dropdown.Toggle id={`row-actions-${id}`} className={cls.Toggle} aria-label="Actions">
        <BsThreeDotsVertical />
      </Dropdown.Toggle>
      <Dropdown.Menu renderOnMount popperConfig={{ strategy: 'fixed' }}>
        {actions.map((action) => (
          <Dropdown.Item
            key={action.label}
            className={action.danger ? cls.DangerItem : undefined}
            disabled={action.disabled}
            onClick={action.onSelect}
          >
            {action.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RowActionsDropdown;
